import React, { useState, useEffect } from 'react';
import Grid from 'components/Custom/Grid';
import { getWorkItemTracking } from 'utils/WorkItemTrackingUtils';
import { getAdditionalFieldsForTable } from 'utils/InspectionsUtils';
import WorkItemTracking from 'classes/WorkItemTracking';
import { useAppContext } from 'hooks/useAppContext';

export default function WorkItemTrackingGrid() {
  const baseColumns = WorkItemTracking.columns;
  const [columns, setColumns] = useState(baseColumns);
  const [columnsKey, setColumnsKey] = useState(0);
  const { selectedProject, selectedProjectData } = useAppContext();

  // Fetch Additional Fields configuration and filter columns
  useEffect(() => {
    console.log('=== Work Item Tracking Grid Column Filter Effect Running ===');
    console.log('selectedProject:', selectedProject);
    console.log('selectedProjectData:', selectedProjectData);

    if (selectedProject && selectedProjectData) {
      getAdditionalFieldsForTable(selectedProject, "WORK ITEM TRACKING")
        .then(additionalFields => {
          console.log('Additional Fields configuration for WORK ITEM TRACKING:', additionalFields);
          console.log('All available field names:', Object.keys(additionalFields));

          // Create case-insensitive lookup
          const fieldLookup = {};
          Object.keys(additionalFields).forEach(key => {
            fieldLookup[key.toLowerCase()] = additionalFields[key];
          });
          console.log('Field lookup (lowercase keys):', fieldLookup);

          // Filter columns based on Additional Fields configuration
          const filteredColumns = baseColumns.filter(column => {
            console.log(`\nChecking column: "${column.title}"`);

            // Try exact match first, then case-insensitive
            let fieldConfig = additionalFields[column.title];
            if (fieldConfig === undefined) {
              fieldConfig = fieldLookup[column.title.toLowerCase()];
            }

            console.log(`  - Additional Fields config for "${column.title}":`, fieldConfig);
            if (fieldConfig !== undefined && fieldConfig === false) {
              console.log(`  ❌ Excluding column "${column.title}" based on Additional Fields config`);
              return false;
            }

            console.log(`  ✅ Including column "${column.title}"`);
            return true;
          });

          console.log(`\n=== SUMMARY: Filtered ${baseColumns.length} columns down to ${filteredColumns.length} columns ===`);
          console.log('Included columns:', filteredColumns.map(c => c.title));
          setColumns(filteredColumns);
          setColumnsKey(prev => prev + 1);
          console.log('Updated columns state and incremented key to force re-render');
        })
        .catch(error => {
          console.error('Error fetching Additional Fields:', error);
          // On error, use all columns
          setColumns(baseColumns);
        });
    } else {
      console.log('Waiting for selectedProject and selectedProjectData to be available...');
    }
  }, [selectedProject, selectedProjectData]);

  return (
    <Grid
      key={columnsKey}
      columns={columns}
      title="Work Item Tracking"
      getRecords={getWorkItemTracking}
      selectedProject={selectedProject}
      component="Inspections"
      enable={{ update: false, delete: false }}
      inspectionColumnTitle="Inspection #"
      options={{
        pageSizeOptions: [10, 15, 25],
        pageSize: 10
      }}
    />
  );
}
